// extracted by mini-css-extract-plugin
module.exports = {"plannings-list":"_3Xm1F","scroll-arrow":"lAfve","visible":"_2i8Cl","left":"_3owXN","right":"AAMRi","scroll-list":"_1diM4","scroll-list-wrapper":"_1DmB8"};